<template>
  <div  class="mb-3">
    <b-form-group
      :class="title_position"
      id="example text"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      <b-form-checkbox
        :class="{ 'is-invalid': v.$error }" 
        value=1
        unchecked-value=0
        v-model="InputName"
        :disabled="FormDataType.Disabled"
        class="mb-3"
        @input="$emit('input', JSON.parse(InputName))"
        checked
        plain 
      ></b-form-checkbox>
      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{  $t("ValidationMessage.required") }}</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { integer } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      InputName: false,
    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: integer,
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
